import React, { useMemo } from 'react';
import {
  FontsFamilySelector,
  FontsWeightSelector,
} from '@bingads-webui-campaign-react/fonts-selector';
import PropTypes from 'prop-types';
import { useStyles } from './style';

const overrideFontWeights = [
  { key: 'Normal', text: _TL_('Normal') },
  { key: 'Bold', text: _TL_('Bold') },
];

export const FontEditor = ({
  i18n,
  onChangeFont,
  onChangeWeight,
  fontsState,
}) => {
  const classes = useStyles();
  const currentFont = useMemo(() => fontsState && fontsState.updating && fontsState.updating.font, [fontsState]);
  const currentWeight = useMemo(() => fontsState && fontsState.updating && fontsState.updating.fontWeight, [fontsState]);

  return (
    <div>
      <div>
        <div className={classes.styleColorTitle}>{i18n.getString(_TL_('Font'))}</div>
        <FontsFamilySelector
          i18n={i18n}
          value={currentFont}
          onChange={onChangeFont}
          selectClassName={classes.fontSelect}
          helpTopic="pop_BA_VideoTemplates_FontStyle"
          helpLabel="Learn more about font style"
        />
      </div>
      <div>
        <div className={classes.styleColorTitle}>{i18n.getString(_TL_('Font weight'))}</div>
        <FontsWeightSelector
          i18n={i18n}
          value={currentWeight}
          onChange={onChangeWeight}
          selectClassName={classes.fontWeightSelect}
          overrideFontWeights={overrideFontWeights}
          helpTopic="pop_BA_VideoTemplates_FontWeight"
          helpLabel="Learn more about font weight"
        />
      </div>
    </div>
  );
};

FontEditor.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  fontsState: PropTypes.shape({
    updating: PropTypes.shape({
      font: PropTypes.string,
      fontWeight: PropTypes.string,
    }),
  }).isRequired,
  onChangeFont: PropTypes.func.isRequired,
  onChangeWeight: PropTypes.func.isRequired,
};

